import { Helmet } from 'react-helmet-async';
import { Link as RouterLink, useLocation } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
import { Button, Typography, Container } from '@mui/material';

// ----------------------------------------------------------------------

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

// Mensagens por detail do GET /signature/{envelope_signer_key}
const SIGNATURE_ERROR_MESSAGES = {
  'Envelope not found': {
    title: 'Documento não encontrado',
    description: 'Este link de assinatura não existe ou o documento não foi encontrado. Verifique se o endereço está correto.',
  },
  'Signature already completed': {
    title: 'Assinatura já realizada',
    description: 'Este documento já foi assinado por você. Não é necessário assinar novamente.',
  },
  'Envelope was canceled': {
    title: 'Documento cancelado',
    description: 'Este documento foi cancelado e não está mais disponível.',
  },
  'Signature is not pending': {
    title: 'Assinatura não está pendente',
    description: 'Este link de assinatura não está mais pendente. O documento pode estar em outra etapa do fluxo.',
  },
  'Envelope group not found': {
    title: 'Grupo não encontrado',
    description: 'O grupo de assinantes vinculado a este link não foi encontrado.',
  },
  'This signature is no longer required. The group has been completed without your signature.': {
    title: 'Assinatura não mais necessária',
    description: 'O grupo foi concluído sem a sua assinatura. Esta assinatura não é mais necessária.',
  },
  'Automatic signature already applied': {
    title: 'Assinatura automática já aplicada',
    description: 'Sua assinatura já foi aplicada automaticamente neste documento. Não é necessário assinar novamente.',
  },
};

function getSignatureMessage(detail) {
  if (typeof detail !== 'string' || !detail) return null;
  const exact = SIGNATURE_ERROR_MESSAGES[detail];
  if (exact) return exact;
  if (detail.includes('Envelope not found')) return SIGNATURE_ERROR_MESSAGES['Envelope not found'];
  if (detail.includes('Signature already completed')) return SIGNATURE_ERROR_MESSAGES['Signature already completed'];
  if (detail.includes('Envelope was canceled')) return SIGNATURE_ERROR_MESSAGES['Envelope was canceled'];
  if (detail.includes('Signature is not pending')) return SIGNATURE_ERROR_MESSAGES['Signature is not pending'];
  if (detail.includes('Envelope group not found')) return SIGNATURE_ERROR_MESSAGES['Envelope group not found'];
  if (detail.includes('no longer required')) return SIGNATURE_ERROR_MESSAGES['This signature is no longer required. The group has been completed without your signature.'];
  if (detail.includes('Automatic signature already applied')) return SIGNATURE_ERROR_MESSAGES['Automatic signature already applied'];
  return null;
}

const DEFAULT_MESSAGE = {
  title: 'Link de assinatura indisponível',
  description: 'Este link de assinatura não existe ou não está mais disponível.',
};

export default function SignatureUnavailablePage() {
  const location = useLocation();
  const signatureError = location.state?.signatureError;
  const msg = getSignatureMessage(signatureError) || DEFAULT_MESSAGE;

  return (
    <>
      <Helmet>
        <title> Link indisponível </title>
      </Helmet>

      <Container>
        <StyledContent sx={{ textAlign: 'center', alignItems: 'center' }}>
          <Typography variant="h3" paragraph>
            {msg.title}
          </Typography>

          <Typography sx={{ color: 'text.secondary', mb: 4 }}>
            {msg.description}
          </Typography>

          <Button to="/" size="large" variant="contained" component={RouterLink}>
            Voltar para Home
          </Button>
        </StyledContent>
      </Container>
    </>
  );
}
